import { combineReducers } from 'redux';
import getLodgingPolicies from 'store/reducers/lodgingPolicy/get-lodging-policies';
import getLodgingPolicy from 'store/reducers/lodgingPolicy/get-lodging-policy';
import postLodgingPolicy from 'store/reducers/lodgingPolicy/post-lodging-policy';

export default combineReducers({
  getLodgingPolicies,
  getLodgingPolicy,
  postLodgingPolicy,
});